























import { defineComponent, ref, watch } from "@vue/composition-api";

import { ConceptMatchItem, Item } from "@/tools/msa/models/item";
import { Token, Section } from "@/tools/msa/models";
import BaseToken from "@/tools/msa/components/document/BaseToken.vue";
import SectionSwitch from "@/tools/msa/components/document/SectionSwitch.vue";
import ContextTooltip from "@/tools/msa/components/ContextTooltip.vue";

interface Props {
  map: Map<Token, Item[]>;
  section: Section;
  selected: Item | null;
}

interface TokenWrapper {
  items: Item[];
  reference: Token;
  selected: boolean;
}

export default defineComponent<Props>({
  name: "BaseSection",
  components: {
    ContextTooltip,
    SectionSwitch,
    BaseToken
  },
  props: {
    map: { type: Map, required: true },
    section: { type: Object, required: true },
    selected: { type: Object, required: false }
  },
  setup(props: Props, context) {
    const emptyArray: Item[] = [];

    const style = ref<Record<string, string>>({});

    const tokens = ref<TokenWrapper[]>([]);

    watch(
      [() => props.section.included],
      () =>
        (style.value = props.section.included
          ? {}
          : { color: "rgba(0, 0, 0, 45%)" }),
      { immediate: true }
    );

    watch(
      () => props.section.included,
      () => {
        context.emit("changed-section");
      }
    );

    watch(
      [() => props.section, () => props.map, () => props.selected],
      () =>
        (tokens.value = props.section.tokens.map(
          (token): Readonly<TokenWrapper> =>
            Object.freeze({
              reference: token,
              items: props.section.included
                ? props.map.get(token)!
                : emptyArray,
              context: props.section.included
                ? props.map
                    .get(token)!
                    .filter(item => item.type === "concept_match")
                    .map(item => item as ConceptMatchItem)
                    .map(item => item.match.context)[0] || {}
                : {},
              selected:
                props.section.included && props.selected
                  ? props.map.get(token)!.includes(props.selected)
                  : false
            })
        )),
      { immediate: true }
    );

    return { tokens, style };
  }
});
